<template>
    <section class="mt-5 mb-5 text-center">
    </section>

</template>

<script>
    import '../assets/css/Technology.css'
    export default {
        name:'TechnologySection',
    }
</script>